<section class="codeing">
  <svg class="codeing_svg">
    <!-- <text  fill="white" x="-50%" y="45px" class="codeing_svg_desktop"><a href="https://cometa.amvara.de/" target="_blank">Java</a></text> -->

      <text  fill="white" x="62%" y="75px" class="codeing_svg_movile"><a href="https://cometa.amvara.de/" target="_blank">Java</a></text>
      <text  fill="white" x="59%" y="75px" class="codeing_svg_tablet"><a href="https://cometa.amvara.de/" target="_blank">Java</a></text>
      <text  fill="white" x="39%" y="75px" class="codeing_svg_desktop"><a href="https://cometa.amvara.de/" target="_blank">Java</a></text>
      <text  fill="white" x="39%" y="75px" class="codeing_svg_landscape"><a href="https://cometa.amvara.de/" target="_blank">Java</a></text>

      <text  fill="white" x="8%" y="155px" class="codeing_svg_movile">Javascript</text>
      <text  fill="white" x="29%" y="145px" class="codeing_svg_tablet">Javascript</text>
      <text  fill="white" x="12%" y="155px" class="codeing_svg_desktop">Javascript</text>
      <text  fill="white" x="14%" y="155px" class="codeing_svg_landscape">Javascript</text>

      <text  fill="white" x="5%" y="450px" class="codeing_svg_movile">
        <a href="https://cometa.amvara.de/" target="_blank">Angular</a>
      </text>
      <text  fill="white" x="15%" y="450px" class="codeing_svg_tablet">
        <a href="https://cometa.amvara.de/" target="_blank">Angular</a>
      </text>
      <text  fill="white" x="-5%" y="450px" class="codeing_svg_desktop">
        <a href="https://cometa.amvara.de/" target="_blank">Angular</a>
      </text>
      <text  fill="white" x="-5%" y="450px" class="codeing_svg_landscape">
        <a href="https://cometa.amvara.de/" target="_blank">Angular</a>
      </text>

      <text  fill="white" x="100%" y="210px" class="codeing_svg_movile">Python</text>
      <text  fill="white" x="95%" y="200px" class="codeing_svg_tablet">Python</text>
      <text  fill="white" x="75%" y="200px" class="codeing_svg_desktop">Python</text>
      <text  fill="white" x="75%" y="200px" class="codeing_svg_landscape">Python</text>

      <text  fill="white" x="25%" y="260px" class="codeing_svg_movile">CSS</text>
      <text  fill="white" x="35%" y="255px" class="codeing_svg_tablet">CSS</text>
      <text  fill="white" x="17%" y="270px" class="codeing_svg_desktop">CSS</text>
      <text  fill="white" x="20%" y="255px" class="codeing_svg_landscape">CSS</text>

      <text  fill="white" x="106%" y="303px" class="codeing_svg_movile">AI</text>  
      <text  fill="white" x="103%" y="303px" class="codeing_svg_tablet">AI</text> 
      <text  fill="white" x="83%" y="303px" class="codeing_svg_desktop">AI</text> 
      <text  fill="white" x="83%" y="303px" class="codeing_svg_landscape">AI</text> 

      <text  fill="white" x="71%" y="360px" class="codeing_svg_movile">Awk</text>
      <text  fill="white" x="68%" y="360px" class="codeing_svg_tablet">Awk</text>
      <text  fill="white" x="48%" y="360px" class="codeing_svg_desktop">Awk</text>
      <text  fill="white" x="48%" y="360px" class="codeing_svg_landscape">Awk</text>

      <text  fill="white" x="48%" y="450px" class="codeing_svg_movile">Bash</text> 
      <text  fill="white" x="52%" y="450px" class="codeing_svg_tablet">Bash</text> 
      <text  fill="white" x="32%" y="450px" class="codeing_svg_desktop">Bash</text>
      <text  fill="white" x="32%" y="450px" class="codeing_svg_landscape">Bash</text> 
      
      <!-- Movile -->
      <circle  cx="55%" cy="70" fill="white" r="7" stroke="none" class="codeing_svg_movile"></circle>
      <circle  cx="50%" cy="165" fill="white" r="4" stroke="none" class="codeing_svg_movile"></circle>
      <circle  cx="91%" cy="202" fill="white" r="7" stroke="none" class="codeing_svg_movile"></circle>
      <circle  cx="48%" cy="270" fill="white" r="7" stroke="none" class="codeing_svg_movile"></circle>
      <circle  cx="65%" cy="355" fill="white" r="4" stroke="none" class="codeing_svg_movile"></circle>
      <circle  cx="55%" cy="420" fill="white" r="7" stroke="none" class="codeing_svg_movile"></circle>
      <circle  cx="100%" cy="300" fill="white" r="4" stroke="none" class="codeing_svg_movile"></circle>
      <circle  cx="20%" cy="420" fill="white" r="7" stroke="none" class="codeing_svg_movile"></circle>   
  
      <line  stroke="white" stroke-width="0.5" x1="55%" x2="50%" y1="70px" y2="165px"  class="codeing_svg_movile"></line>
      <line  stroke="white" stroke-width="0.5" x1="50%" x2="90%" y1="165" y2="200" class="codeing_svg_movile"></line>
      <line  stroke="white" stroke-width="0.5" x1="90%" x2="48%" y1="205" y2="270" class="codeing_svg_movile"></line>
      <line  stroke="white" stroke-width="0.5" x1="50%" x2="48%" y1="165" y2="270" class="codeing_svg_movile"></line>
      <!-- Bash -->
      <line  stroke="white" stroke-width="0.5" x1="55%" x2="48%" y1="420px" y2="270" class="codeing_svg_movile"></line>
      <!-- Awk -->
      <line  stroke="white" stroke-width="0.5" x1="65%" x2="48%" y1="355px" y2="270" class="codeing_svg_movile"></line>
      <!-- Ai -->
      <line  stroke="white" stroke-width="0.5" x1="100%" x2="91%" y1="300px" y2="200" class="codeing_svg_movile"></line>
      <!-- Angular -->
      <line  stroke="white" stroke-width="0.5" x1="48%" x2="20%" y1="270px" y2="420" class="codeing_svg_movile"></line>

      <!-- ------------------- tablet ------------------- -->

      <circle  cx="55%" cy="70" fill="white" r="7" stroke="none" class="codeing_svg_tablet"></circle>
      <circle  cx="50%" cy="165" fill="white" r="4" stroke="none" class="codeing_svg_tablet"></circle>
      <circle  cx="91%" cy="202" fill="white" r="7" stroke="none" class="codeing_svg_tablet"></circle>
      <circle  cx="48%" cy="270" fill="white" r="7" stroke="none" class="codeing_svg_tablet"></circle>
      <circle  cx="65%" cy="355" fill="white" r="4" stroke="none" class="codeing_svg_tablet"></circle>
      <circle  cx="55%" cy="420" fill="white" r="7" stroke="none" class="codeing_svg_tablet"></circle>
      <circle  cx="100%" cy="300" fill="white" r="4" stroke="none" class="codeing_svg_tablet"></circle>
      <circle  cx="20%" cy="420" fill="white" r="7" stroke="none" class="codeing_svg_tablet"></circle>   
  
      <line  stroke="white" stroke-width="0.5" x1="55%" x2="50%" y1="70px" y2="165px"  class="codeing_svg_tablet"></line>

      <line  stroke="white" stroke-width="0.5" x1="50%" x2="90%" y1="165px" y2="200px" class="codeing_svg_tablet"></line>

      <line  stroke="white" stroke-width="0.5" x1="90%" x2="48%" y1="205px" y2="270px" class="codeing_svg_tablet"></line>

      <line  stroke="white" stroke-width="0.5" x1="50%" x2="48%" y1="165px" y2="270px" class="codeing_svg_tablet"></line>
      <!-- Bash -->
      <line  stroke="white" stroke-width="0.5" x1="55%" x2="48%" y1="420px" y2="270px" class="codeing_svg_tablet"></line>
      <!-- Awk -->
      <line  stroke="white" stroke-width="0.5" x1="65%" x2="48%" y1="355px" y2="270px" class="codeing_svg_tablet"></line>
      <!-- Ai -->
      <line  stroke="white" stroke-width="0.5" x1="100%" x2="91%" y1="300px" y2="200px" class="codeing_svg_tablet"></line>
      <!-- Angular -->
      <line  stroke="white" stroke-width="0.5" x1="48%" x2="20%" y1="270px" y2="420px" class="codeing_svg_tablet"></line>

      <!-- ------------------- desktop ------------------- -->

      <circle  cx="35%" cy="70" fill="white" r="7" stroke="none" class="codeing_svg_desktop"></circle>
      <circle  cx="30%" cy="165" fill="white" r="4" stroke="none" class="codeing_svg_desktop"></circle>
      <circle  cx="71%" cy="202" fill="white" r="7" stroke="none" class="codeing_svg_desktop"></circle>
      <circle  cx="28%" cy="270" fill="white" r="7" stroke="none" class="codeing_svg_desktop"></circle>
      <circle  cx="45%" cy="355" fill="white" r="4" stroke="none" class="codeing_svg_desktop"></circle>
      <circle  cx="35%" cy="420" fill="white" r="7" stroke="none" class="codeing_svg_desktop"></circle>
      <circle  cx="80%" cy="300" fill="white" r="4" stroke="none" class="codeing_svg_desktop"></circle>
      <circle  cx="0%" cy="420" fill="white" r="7" stroke="none" class="codeing_svg_desktop"></circle>   

      <line  stroke="white" stroke-width="0.5" x1="35%" x2="30%" y1="70px" y2="165px"  class="codeing_svg_desktop"></line>
      
      <line  stroke="white" stroke-width="0.5" x1="30%" x2="70%" y1="165px" y2="200px" class="codeing_svg_desktop"></line>

      <line  stroke="white" stroke-width="0.5" x1="70%" x2="28%" y1="205px" y2="270px" class="codeing_svg_desktop"></line>

      <line  stroke="white" stroke-width="0.5" x1="30%" x2="28%" y1="165px" y2="270px" class="codeing_svg_desktop"></line>
      <!-- Bash -->
      <line  stroke="white" stroke-width="0.5" x1="35%" x2="28%" y1="420px" y2="270px" class="codeing_svg_desktop"></line>
      <!-- Awk -->
      <line  stroke="white" stroke-width="0.5" x1="45%" x2="28%" y1="355px" y2="270px" class="codeing_svg_desktop"></line>
      <!-- Ai -->
      <line  stroke="white" stroke-width="0.5" x1="80%" x2="71%" y1="300px" y2="200px" class="codeing_svg_desktop"></line>
      <!-- Angular -->
      <line  stroke="white" stroke-width="0.5" x1="28%" x2="0%" y1="270px" y2="420px" class="codeing_svg_desktop"></line>

      
      <!-- ------------------- landscape ------------------- -->

      <circle  cx="35%" cy="70" fill="white" r="7" stroke="none" class="codeing_svg_landscape"></circle>
      <circle  cx="30%" cy="165" fill="white" r="4" stroke="none" class="codeing_svg_landscape"></circle>
      <circle  cx="71%" cy="202" fill="white" r="7" stroke="none" class="codeing_svg_landscape"></circle>
      <circle  cx="28%" cy="270" fill="white" r="7" stroke="none" class="codeing_svg_landscape"></circle>
      <circle  cx="45%" cy="355" fill="white" r="4" stroke="none" class="codeing_svg_landscape"></circle>
      <circle  cx="35%" cy="420" fill="white" r="7" stroke="none" class="codeing_svg_landscape"></circle>
      <circle  cx="80%" cy="300" fill="white" r="4" stroke="none" class="codeing_svg_landscape"></circle>
      <circle  cx="0%" cy="420" fill="white" r="7" stroke="none" class="codeing_svg_landscape"></circle>   
  
      <line  stroke="white" stroke-width="0.5" x1="35%" x2="30%" y1="70px" y2="165px"  class="codeing_svg_landscape"></line>
      
      <line  stroke="white" stroke-width="0.5" x1="30%" x2="70%" y1="165px" y2="200px" class="codeing_svg_landscape"></line>

      <line  stroke="white" stroke-width="0.5" x1="70%" x2="28%" y1="205px" y2="270px" class="codeing_svg_landscape"></line>

      <line  stroke="white" stroke-width="0.5" x1="30%" x2="28%" y1="165px" y2="270px" class="codeing_svg_landscape"></line>
      <!-- Bash -->
      <line  stroke="white" stroke-width="0.5" x1="35%" x2="28%" y1="420px" y2="270px" class="codeing_svg_landscape"></line>
      <!-- Awk -->
      <line  stroke="white" stroke-width="0.5" x1="45%" x2="28%" y1="355px" y2="270px" class="codeing_svg_landscape"></line>
      <!-- Ai -->
      <line  stroke="white" stroke-width="0.5" x1="80%" x2="71%" y1="300px" y2="200px" class="codeing_svg_landscape"></line>
      <!-- Angular -->
      <line  stroke="white" stroke-width="0.5" x1="28%" x2="0%" y1="270px" y2="420px" class="codeing_svg_landscape"></line>

  </svg>

</section>
